import React from 'react';
import { createPortal } from 'react-dom';
import './AskModal.scss';
import { useTranslation } from 'react-i18next';

const AskModal = ({
  visible,
  title,
  description,
  confirmText,
  cancelText,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation('utils');

  const targetElement = document.getElementById('modal-root');

  if (!visible || !targetElement) return null;
  return createPortal(
    <div className="fullscreen" onClick={onCancel}>
      <div className="AskModalBlock">
        {title ? (
          <div className="title font_regular text_greyishBrown">{title}</div>
        ) : null}
        <div className="description font_regular text_greyishBrown">
          {description}
        </div>
        <div className="buttons">
          {onCancel && (
            <div
              className="cancelBtn font_regular text_purple"
              onClick={onCancel}
            >
              {cancelText || t('cancel')}
            </div>
          )}
          <div
            className="confirmBtn font_regular text_purple"
            onClick={onConfirm}
          >
            {confirmText || t('confirm')}
          </div>
        </div>
      </div>
    </div>,
    targetElement,
  );
};

export default AskModal;
